/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 8/11/2023
 */


import { apiSlice } from "../Slices/apiSlice";

export const OfferService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllOffers: builder.query({
            query: () => "/offers",
            providesTags: ["offer"],
        }),

        getOfferById: builder.query({
            query: (offerId) => `offers/${offerId}`,
            providesTags: ["offer"],
        }),

        createOffer: builder.mutation({
            query: (Details) => ({
                url: `/offers`,
                method: 'POST',
                body: Details
            }),
            invalidatesTags: ["offer"],
        }),

        updateOffer: builder.mutation({
            query: (Details) => ({
                url: `/offers/${Details.offerId}`,
                method: 'PUT',
                body: Details
            }),
            invalidatesTags: ["offer"],
        }),

        deleteOffer: builder.mutation({
            query: (id) => ({
                url: `offers/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["offer"],
        }),

    })
});

export const {
    useGetAllOffersQuery,
    useGetOfferByIdQuery,
    useCreateOfferMutation,
    useUpdateOfferMutation,
    useDeleteOfferMutation,
} = OfferService;